'use client';

import React from 'react';
import { Question } from '../types';
import { QuizItem } from '@/store/assessment-store';
import { renderReviewOptions } from './options/OptionRendererFactory';

/**
 * Single Responsibility: Render question options in review mode
 * Uses factory pattern for extensibility (Open/Closed Principle)
 */
interface QuestionOptionsReviewProps {
  question: Question;
  questionType: string;
  questionIndex: number;
  quiz: QuizItem[];
  showCorrectness?: boolean;
  getOptionCorrectness?: (option: string | boolean) => boolean | null;
  correctAnswers?: string | string[] | boolean | null;
}

export function QuestionOptionsReview({
  question,
  questionType,
  questionIndex,
  quiz,
  showCorrectness = false,
  getOptionCorrectness,
  correctAnswers = null,
}: QuestionOptionsReviewProps) {
  const quizArray = Array.isArray(quiz) ? quiz : [];
  const quizItem = quizArray.find((q) => q.question_uid === question.metadata_uid);
  const selectedOptions = quizItem?.selected_options;

  return (
    <>
      {renderReviewOptions({
        question,
        questionType,
        questionIndex,
        selectedOptions,
        showCorrectness,
        correctnessChecker: getOptionCorrectness,
        correctAnswers,
      })}
    </>
  );
}

